const LOGIN_ROUTE = '/admin/login';

export default defineNuxtRouteMiddleware(() => {
  const { authState, onAuthChange } = useAuth();
  if (authState.value != 'pending') {
    return authState.value == 'logged_out' ? { path: LOGIN_ROUTE } : undefined;
  }
  return new Promise(resolve => {
    onAuthChange(state => {
      resolve(state == 'logged_out' ? { path: LOGIN_ROUTE } : undefined);
    });
  });
});